import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { tabButtons, TABS } from "pages/price-management/Bundles/bundleDetails/constants";
import EditBundleTab from "pages/price-management/Bundles/bundleDetails/Tabs/EditBundleTab";
import BundleAssignmentsTab from "pages/price-management/Bundles/bundleDetails/Tabs/BundleAssignmentsTab";
import CustomerDirectAssignmentsTab from "pages/price-management/Bundles/bundleDetails/Tabs/CustomerDirectAssignmentsTab";

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 60,
    display: "flex",
    backgroundColor: "#FFF",
    border: "1px solid #0000001A",
    borderRadius: 5,
  },
  container: {
    width: "100%",
  },
  tabs: {
    display: "flex",
    fontSize: 13,
    fontWeight: 600,
    flexDirection: "column",
    width: "25%",
    borderRight: "1px solid #0000001A",
  },
  tab: {
    display: "flex",
    padding: 15,
    whiteSpace: "nowrap",
    borderBottom: "1px solid #0000001A",
    position: "relative",

    "&:hover": {
      cursor: "pointer",
    },
  },
  active: {
    backgroundColor: "#FFFFFF!important",
    zIndex: 9,

    "&:after": {
      content: "''",
      top: 0,
      right: -2,
      width: 4,
      height: "100%",
      position: "absolute",
      backgroundColor: "#FFFFFF",
    },
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 700,
    fontSize: 13,
    width: "100%",
    marginLeft: 15,

    "&>div": {
      fontSize: 9,
      fontWeight: 300,
      color: "#8C8C8C",
    },
  },
});

const DataTabs = ({ data, assignments, assignmentsGroups, logs, customerGroupList, update, setIsLoading }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(TABS.EDIT_BUNDLE);

  const onTabClick = useCallback(e => {
    const tab = e.currentTarget.dataset.tab;
    setActiveTab(tab);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {tabButtons.map(item => (
          <div
            key={item.key}
            className={classnames(classes.tab, activeTab === item.key && classes.active)}
            data-tab={item.key}
            onClick={onTabClick}
          >
            <img src={item.icon} alt="general info" />
            <div className={classes.titleContainer}>
              {item.title}
              <div>{item.subTitle}</div>
            </div>
          </div>
        ))}
      </div>
      <div className={classes.container}>
        {activeTab === TABS.EDIT_BUNDLE && (
          <EditBundleTab hasAssignments={!!assignments?.items?.length} data={data} setIsLoading={setIsLoading} />
        )}
        {activeTab === TABS.BUNDLE_ASSIGNMENTS && (
          <BundleAssignmentsTab
            customerGroupList={customerGroupList}
            data={data}
            logs={logs}
            assignmentsGroups={assignmentsGroups.other}
            setIsLoading={setIsLoading}
            update={update}
          />
        )}
        {activeTab === TABS.CUSTOMER_DIRECT && (
          <CustomerDirectAssignmentsTab
            customerGroupList={customerGroupList}
            data={data}
            logs={logs}
            assignmentsGroups={assignmentsGroups.customer}
            setIsLoading={setIsLoading}
            update={update}
          />
        )}
      </div>
    </div>
  );
};

export default DataTabs;
